import UiElement from '../../../shared/ui-element/ui-element';

export default class PromoApps extends UiElement {
  constructor(bgClasses = {}) {
    super();

    this.bgClasses = bgClasses;

    this.collectionsBgClasses = {
      enhanceMac: 'promo-apps_bg-green',
      elevateWork: 'promo-apps_bg-blue',
      optimizeLife: 'promo-apps_bg-purple',
      ios: 'promo-apps_bg-dirty-purple',
      ...this.bgClasses,
    };
  }

  ui = {
    promoAppsSection: '.js-promo-apps-section',
    promoAppsSelect: '.js-promo-apps-select',
  };

  uiCollections = {
    promoAppsCollections: '.js-promo-apps-collection',
    promoAppsRadioSwitcher: '.js-promo-apps-radio-switcher',
  };

  events = {
    'click @uiCollections.promoAppsRadioSwitcher': 'handlePromoAppCollectionSelect',
    'change @ui.promoAppsSelect': 'handlePromoAppCollectionSelect',
  };

  handlePromoAppCollectionSelect(e) {
    this.selectActivePromoCollection(e.currentTarget.value);
  }

  selectActivePromoCollection(collectionName) {
    // keep radio buttons and select in sync
    this.ui.promoAppsSelect.value = collectionName;
    this.uiCollections.promoAppsRadioSwitcher.forEach((radioButton) => {
      // eslint-disable-next-line no-param-reassign
      radioButton.checked = radioButton.value === collectionName;
    });

    const bgClasses = Object.keys(this.collectionsBgClasses)
      .map((key) => this.collectionsBgClasses[key]);
    this.ui.promoAppsSection.classList.remove(...bgClasses);
    this.ui.promoAppsSection.classList.add(this.collectionsBgClasses[collectionName]);

    this.uiCollections.promoAppsCollections
      .forEach((collection) => collection.classList.toggle('d-none', collection.dataset.collection !== collectionName));
  }
}
